import { api } from '~config/api';

const refundTransaction = ({ id, values, paymentType }) => {
  return api.post(`v1/admin/payments/${paymentType}/${id}/refund_transaction`, {
    refund_data: { notes: values.notes }
  });
};

export default {
  refundTransaction
};
